import React, { useState, useEffect } from 'react';
import { Input, Tooltip } from 'antd';
import { CloseOutlined, HolderOutlined } from '@ant-design/icons';
import { ReactSortable } from 'react-sortablejs';

const ListeDeroulante = ({ options = [], editable = true, onChange }) => {
  const [localOptions, setLocalOptions] = useState([]);

  // Init options une seule fois
  useEffect(() => {
    const initialOptions = options.map((text, i) => ({
      id: `${i}-${Date.now()}`,
      text,
    }));
    setLocalOptions(initialOptions);
  }, []);

  const handleOptionChange = (value, index) => {
    const updated = [...localOptions];
    updated[index] = { ...updated[index], text: value };
    setLocalOptions(updated);
    onChange?.(updated.map((opt) => opt.text));
  };

  const handleAddOption = () => {
    const newOption = {
      id: `${Date.now()}`,
      text: `Option ${localOptions.length + 1}`,
    };
    const updated = [...localOptions, newOption];
    setLocalOptions(updated);
    onChange?.(updated.map((opt) => opt.text));
  };

  const handleRemoveOption = (index) => {
    if (index === 0) return;
    const updated = localOptions.filter((_, i) => i !== index);
    setLocalOptions(updated);
    onChange?.(updated.map((opt) => opt.text));
  };

  return (
    <div style={{ width: '100%' }}>
      <ReactSortable
        list={localOptions}
        setList={(newList) => {
          setLocalOptions(newList);
          onChange?.(newList.map((o) => o.text));
        }}
        animation={150}
        handle=".dragHandle"
      >
        {localOptions.map((option, index) => (
          <div
            key={option.id}
            className="option-item"
            style={{
              display: 'flex',
              alignItems: 'center',
              width: '100%',
              marginBottom: '4%',
              position: 'relative',
            }}
          >
            {editable && (
              <div
                className="dragHandle"
                style={{
                  cursor: 'move',
                  marginLeft: -20,
                  opacity: 0,
                  transition: 'opacity 0.2s',
                  color: '#999',
                  fontSize: 20,
                }}
              >
                <HolderOutlined />
              </div>
            )}
            <div style={{ width: 20, textAlign: 'center' }}>{index + 1}.</div>

            {editable ? (
              <Input variant='underlined'
                value={option.text}
                onChange={(e) => handleOptionChange(e.target.value, index)}
                style={{ width: '85%', marginLeft: 8 }}
              />
            ) : (
              <span style={{ marginLeft: 8 }}>{option.text}</span>
            )}

            {editable && index !== 0 && (
              <Tooltip title="Supprimer">
                <CloseOutlined
                  style={{ fontSize: 20, marginLeft: 8, cursor: 'pointer' }}
                  onClick={() => handleRemoveOption(index)}
                />
              </Tooltip>
            )}
          </div>
        ))}
      </ReactSortable>

      {editable && (
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            width: '100%',
            marginTop: 12,
            cursor: 'pointer',
          }}
          onClick={handleAddOption}
        >
          <div style={{ width: 20, textAlign: 'center' }}>{localOptions.length + 1}.</div>
          <span style={{ marginLeft: 8 }}>Ajouter une option</span>
        </div>
      )}

      {/* Style : afficher HolderOutlined au hover */}
      <style>
        {`
          .option-item:hover .dragHandle {
            opacity: 3 !important;
          }
        `}
      </style>
    </div>
  );
};

export default ListeDeroulante;
